export default __webpack_public_path__ + "static/media/negotiation-nodata.d7e7df05.svg";